import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

const getStored = () => {
  try { return localStorage.getItem("rdi_lang"); } catch { return null; }
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(getStored() || "fr");

  useEffect(() => {
    document.documentElement.lang = lang;
    try { localStorage.setItem("rdi_lang", lang); } catch {}
  }, [lang]);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) { node = node?.[p]; if (node === undefined) break; }
    if (node === undefined) return path;
    return node;
  }, [lang]);

  // pick fr/en value from a CMS bilingual object, or return raw string
  const pick = useCallback((val) => {
    if (val == null) return "";
    if (typeof val === "object" && ("fr" in val || "en" in val)) return val[lang] ?? val.fr ?? "";
    return val;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t, pick }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
